import { createAsyncThunk } from '@reduxjs/toolkit';
import { UserService } from '../../services/UserService';
import { fetchClaimsActionName } from './actionTypes';

const service = UserService;
export const fetchClaimsAction = createAsyncThunk(fetchClaimsActionName, async () => {
  return service.getClaims();
});
